import { render, staticRenderFns } from "./TableStriped.vue?vue&type=template&id=792c367d"
import script from "./TableStriped.vue?vue&type=script&lang=js"
export * from "./TableStriped.vue?vue&type=script&lang=js"
import style0 from "./TableStriped.vue?vue&type=style&index=0&id=792c367d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports